import axios from 'axios';
import { setCurrentAppId } from './utils/api-helper';

axios.defaults.baseURL = process.env.BASE_API_URL || '';
axios.defaults.withCredentials = true;
// Set app ID for token refresh interceptor
// eslint-disable-next-line no-underscore-dangle
if (window.__APP_ID__) {
  // eslint-disable-next-line no-underscore-dangle
  setCurrentAppId(window.__APP_ID__);
}
